<template>
  <div class="container container--nav">
    <div class="nav__items">
      <div class="nav__item item-wpl-logo"><img src="../assets/images/whirlpool.svg" /></div>
      <div class="nav__item"><img src="../assets/images/hotpoint.svg" /></div>
      <div class="nav__item"><img src="../assets/images/baucknecht.svg" /></div>
      <div class="nav__item"><img src="../assets/images/indesit.svg" /></div>
      <div class="nav__item"><img src="../assets/images/privileg.svg"  ></div>
      <div class="nav__item ignis"><img src="../assets/images/ignis.jpg" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
}
</script>